<script lang="ts">
	import LandingPage from '$lib/pages/landingpage/LandingPage.svelte';
</script>

<svelte:head>
	<title>Supertip: Community & Engagement Tools for Live Streamers</title>
</svelte:head>
<LandingPage />
